import {AxiosError} from 'axios';
import {POST_CREATE_NEW_USER_GROUP_URL} from 'web-library/constants/apiUrls';
import {
  CreateEditNewUserGroupRequestBody
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateNewUserGroup = ({onError, onSuccess}: Input = {}) => {
  const postCreateNewUserGroup = async (reqBody: CreateEditNewUserGroupRequestBody) => {
    const res = await axiosClient.post<void>(POST_CREATE_NEW_USER_GROUP_URL, reqBody);

    return res.data;
  };

  return useCustomMutation(postCreateNewUserGroup, {
    onSuccess,
    onError,
  });
};
